export default __webpack_public_path__ + "fonts/ubuntu-cyrillic-ext-400-normal-fe8ca0.woff";